import React from "react";

import GlobalStyles from "./components/GobalStyle";
import HomePage from "./components/HomePage";
import LogoEntrance from "./components/LogoEntrance";

const App = () => (
  <div>
    <GlobalStyles />
    <LogoEntrance />
    <HomePage />
  </div>
);

export default App;
